import { render } from "./AllResultsFileUpload.vue?vue&type=template&id=1484aebb"
import script from "./AllResultsFileUpload.vue?vue&type=script&lang=js"
export * from "./AllResultsFileUpload.vue?vue&type=script&lang=js"

import "./AllResultsFileUpload.vue?vue&type=style&index=0&id=1484aebb&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/results/AllResultsFileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1484aebb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1484aebb', __exports__)) {
    console.log('reload')
    api.reload('1484aebb', __exports__)
  }
  
  module.hot.accept("./AllResultsFileUpload.vue?vue&type=template&id=1484aebb", () => {
    console.log('re-render')
    api.rerender('1484aebb', render)
  })

}


export default __exports__